export const Constants = {
  NDA_CONTENT: 'no-data-available-content',
  NDA_TEXT: 'no-data-available-text',
  TAG_NAME: 'pop-no-data-available-component',
  DATA_MESSAGE: 'data-message',
  DEFAULT_MESSAGE: 'Data is unavailable',
} as const;
